import { Common } from "./index";

export const RevenueType = Object.freeze({ FIXED: "fixed", DYNAMIC: "dynamic", ...Common });
